// Main Scripts
// ---------------------
import mainSlideshow from './js/widgets/mainSlideshow.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import cardWithIcons from './js/widgets/cardWithIcons.js';
import customMultiGallery from './js/widgets/customMultiGallery.js';
import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import sponsors from './js/widgets/sponsors.js';

// Secondary Scripts
// ---------------------
import './js/localjs.js';

if (window.location.pathname === '/') {
  $(document).ready(function () {
    multiScheduleFeature();
    mainSlideshow();
    cardWithIcons();
    customMultiGallery('galleryOne', galleryOneOpts);
    customMultiGallery('galleryTwo', galleryTwoOpts);
    customMultiGallery('galleryThree', galleryThreeOpts);
    customMultiGallery('galleryFour', galleryFourOpts);
    seoWidget();
    sponsors();
  });
  $(window).load(function () {
    videoWidget();
  });
}
